// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".searchWrapper--24vpzIw1 {\n  display: flex;\n}\n\n.SearchTree--3KtyTzui {\n  flex: 1;\n}\n\n.searchContent--17OZ-7EE {\n  flex: 1;\n  overflow: auto;\n}\n\n.searchContentTopTools--NgfMZvWn {\n  padding: 5px;\n  text-align: right;\n}\n\n.externalIcon--29Ko_Z7q {\n  margin-left: 6px;\n  color: #bdbdbd;\n  display: inline-block;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"searchWrapper": "searchWrapper--24vpzIw1",
	"SearchTree": "SearchTree--3KtyTzui",
	"searchContent": "searchContent--17OZ-7EE",
	"searchContentTopTools": "searchContentTopTools--NgfMZvWn",
	"externalIcon": "externalIcon--29Ko_Z7q"
};
export default ___CSS_LOADER_EXPORT___;
